import { render, staticRenderFns } from "./EmdTabbar.vue?vue&type=template&id=2dae86a1&"
import script from "./EmdTabbar.vue?vue&type=script&lang=js&"
export * from "./EmdTabbar.vue?vue&type=script&lang=js&"
import style0 from "./EmdTabbar.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* custom blocks */
import block0 from "./EmdTabbar.vue?vue&type=custom&index=0&blockType=i18n"
if (typeof block0 === 'function') block0(component)

/* hot reload */
if (module.hot) {
  var api = require("/data/vstsagent03/user/3333/s/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('2dae86a1')) {
      api.createRecord('2dae86a1', component.options)
    } else {
      api.reload('2dae86a1', component.options)
    }
    module.hot.accept("./EmdTabbar.vue?vue&type=template&id=2dae86a1&", function () {
      api.rerender('2dae86a1', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/emerald/organisms/EmdTabbar.vue"
export default component.exports